import { Box, Modal, Typography } from '@mui/material';
import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import CustomInput from 'components/CustomInput/customInput';
import { yupResolver } from '@hookform/resolvers/yup';
import { CommentSchema } from 'utils/ValidatorSchema';
import Closepng from 'assets/png/close.svg';

interface Props {
  open: boolean;
  setOpen: (open: boolean) => void;
  handleFormSubmit: (data: any) => void;
}

const CommentsPopUp: React.FC<Props> = ({ open,setOpen,handleFormSubmit }) => {
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm<any>({
    defaultValues: {
      reason: '',
    },
    reValidateMode: 'onChange',
    resolver: yupResolver(CommentSchema),
  });
  const onClose = () => {
    setOpen(false);
    reset();
  };


  return (
    <Modal open={open} onClose={onClose}>
      <form className='private-form' id={'user-add'} onSubmit={handleSubmit(handleFormSubmit)}>
        <Box className='spoc-list-modal center'>
          <img src={Closepng} alt='close' className='closepng' onClick={onClose} />
          <Typography component={'div'} className='custom-field'>
            <Typography component={'div'} className='reason-for-editing'>
              Reason For Editing
            </Typography>
            <Typography component={'p'}>
              Reason<span>*</span>
            </Typography>
            <Controller
              control={control}
              name='reason'
              render={({ field: { onChange, value, name } }) => (
                <CustomInput
                  value={value}
                  name={name}
                  onChange={(e) => onChange(e)}
                  placeHolder='Type your reason'
                  isTextArea={true}
                  error={errors.reason?.message}
                  className={`custom-input client-comment-box ${
                    errors.reason?.message ? 'client-comment-box-error' : ''
                  }`}
                />
              )}
            />
          </Typography>
          <div className='button-con end'>
            <div className='buttons editreason-btn'>
              <button onClick={onClose} className='editreason-btn-close'>
                Cancel
              </button>
              <button type='submit' className='editreason-btn-submit'>
                Submit
              </button>
            </div>
          </div>
        </Box>
      </form>
    </Modal>
  );
};

export default CommentsPopUp;
